import React from 'react'
import { makeTitleCase } from '../../../utils'
import NumberFormat from 'react-number-format'
import './stats.css'
import Grid from '@mui/material/Grid'

const BikeStats = (props) => {
  return (
    <Grid
      container
      direction="row"
      justifyContent="flex-start"
      spacing={2}
      className="stat-item-container"
    >
      {props.bikeData.bike_category && (
        <Grid item md={3} xs={6} className="stat-item">
          <i className="fa fa-motorcycle fa-lg"></i>
          {makeTitleCase(props.bikeData.bike_category)}
        </Grid>
      )}
      {props.bikeData.bike_weight && (
        <Grid item md={3} xs={6} className="stat-item">
          <i className="fal fa-weight-hanging fa-lg"></i>
          <NumberFormat
            value={props.bikeData.bike_weight}
            displayType={'text'}
            thousandSeparator={true}
          />
          lbs
        </Grid>
      )}
      {props.bikeData.bike_engine && (
        <Grid item md={3} xs={6} className="stat-item">
          <i className="fal fa-flag-checkered fa-lg"></i>
          <NumberFormat
            value={props.bikeData.bike_engine}
            displayType={'text'}
            thousandSeparator={true}
          />
          CC
        </Grid>
      )}
      {props.bikeData.bike_seat_height && (
        <Grid item md={3} xs={6} className="stat-item">
          <i className="fal fa-arrows-v"></i>
          {props.bikeData.bike_seat_height}"
        </Grid>
      )}
    </Grid>
  )
}

export default BikeStats
